/* jshint esversion: 6 */
import React from 'react';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import Toggle from 'app/components/common/ToggleControl.jsx';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import FilterPanel from 'app/components/EditorComponents/FilterPanel.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class InputFilterPanel extends React.Component {
	render() {
		var andFilter = (this.props.input.andFilter) ? this.props.input.andFilter : '',
			orFilter = (this.props.input.orFilter) ? this.props.input.orFilter : '',
			notFilter = (this.props.input.notFilter) ? this.props.input.notFilter : '',
			behavior = (this.props.input.filterBehavior) ? this.props.input.filterBehavior : 0,
			titleActive = (this.props.input.filtersTitle) ? true : false,
			categoryActive = (this.props.input.filtersCategory) ? true : false,
			contentActive = (this.props.input.filtersContent) ? true : false,
			authorActive = (this.props.input.filtersAuthor) ? true : false,
			linkActive = (this.props.input.filtersLink) ? true : false;

		return (
			<FilterPanel
				updateField={this.props.changeHandler}
				andFilter={andFilter}
				orFilter={orFilter}
				notFilter={notFilter}
				behavior={behavior}
				titleActive={titleActive}
				categoryActive={categoryActive}
				contentActive={contentActive}
				authorActive={authorActive}
				linkActive={linkActive}
				stateName={this.props.statePath}
				errors={this.props.errors} />
		);
	}
};

InputFilterPanel.displayName = "InputFilterPanel";

export default ComponentWithContext(InputFilterPanel);
